import { render } from "./ListSubCommunityDashboardView.vue?vue&type=template&id=48464136"
import script from "./ListSubCommunityDashboardView.vue?vue&type=script&lang=js"
export * from "./ListSubCommunityDashboardView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__